<template>
  <div class="login-wrap">
    <div class="login-txt">为了更好的体验</div>
    <div class="login-txt">
      微信一键登录，更方便，更安全
    </div>
    <button class="login-button" :disabled="loading" @click="wxAuth">
      {{ loading ? '登录中...' : '微信登录' }}
    </button>
  </div>
</template>

<script>
import config from '@/config'
import { getQueryString } from '@/utils/common'
import { storage } from '@/utils/storage'

export default {
  name: 'Login',
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    // 从 URL 或路由 query 读取并缓存 svapid、redirectUrl
    const svapid = (this.$route.query.svapid) || getQueryString('svapid')
    const appid = (this.$route.query.appid) || getQueryString('appid')
    const redirectUrl = (this.$route.query.redirectUrl) || getQueryString('redirectUrl')
    if (svapid) {
      storage.set('author_wx_appid', svapid)
    }

    if (redirectUrl) {
      storage.set('author_redirect_url', redirectUrl)
    }
  },
  methods: {
    wxAuth () {
      if (this.loading) return
      this.loading = true
      try {
        const svapid = getQueryString('svapid') || storage.get('author_wx_appid')
        const appid = getQueryString('appid') || storage.get('appid') || config.wxH5.appId
        // const redirectUrl = getQueryString('redirectUrl') || storage.get('author_redirect_url')
        if (!svapid) {
          this.$createToast({ type: 'warn', time: 1200, txt: '缺少参数：svapid' }).show()
          return
        }
        if (appid) {
          storage.set("appid",appid)
        }
        // if (redirectUrl){
        //   storage.set("author_redirect_url",redirectUrl)
        // }

        const state = Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
        storage.set('author_wx_state', state)

        // const base = ( window.location.host || '').replace(/\/+$/, '')
        // history 模式回调地址
        const redirectUri = encodeURIComponent(config.baseUrl + '/redirect')
        const scope = (config.wxH5 && config.wxH5.scope) || 'snsapi_userinfo'
        const authorizeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'

        const url =
          authorizeUrl +
          '?appid=' + encodeURIComponent(appid) +
          '&redirect_uri=' + redirectUri +
          '&response_type=code' +
          '&scope=' + encodeURIComponent(scope) +
          '&state=' + encodeURIComponent(state) +
          '#wechat_redirect'

        window.location.replace(url)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-wrap {
    height: 100%;
    width: 100%;
    position: absolute;
    padding-top: 4rem;
    /* background: #f4f5f9; */
}
.login-txt {
  text-align: center;
  width: 100%;
  line-height: 1.2;
  color: #333;
  font-size: 1.2rem;
}
.login-button {
  display: block;
  margin: 2.2rem auto 0;
  width: 80%;
  max-width: 16rem;
  line-height: 2;
  padding: 0.28rem 0;
  font-size: 1.2rem;
  border: none;
  border-radius: 2rem;
  background-color: #07C160;
  color: #fff;
  cursor: pointer;
}
.login-button:active {
  background-color: #06AD56;
}
.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue